import type { ProductHit } from '@libs/algolia';
import { productRatingsMapper } from '@app/pdp/components/ProductRatings/utils';
import { useMemo } from 'react';
import type { ProductRatings } from '@app/pdp/components/ProductRatings/types';

export const useProductRatingsMapper = (product?: ProductHit) =>
    useMemo((): ProductRatings => productRatingsMapper(product), [product]);
